
import { Priority } from "@/types/habit";

interface HabitCardHeaderProps {
  title: string;
  emoji: string;
  priority: Priority;
}

export const HabitCardHeader = ({ title, emoji, priority }: HabitCardHeaderProps) => {
  return (
    <div className="flex items-start justify-between">
      <div className="flex items-start space-x-3">
        <span className="text-4xl">{emoji}</span>
        <div>
          <h3 className="text-xl font-parkinsans font-semibold text-gray-800">
            {title}
          </h3>
          <p className="text-sm text-gray-500 mt-1">
            {priority.charAt(0).toUpperCase() + priority.slice(1)} Priority
          </p>
        </div>
      </div>
    </div>
  );
};
